// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__nU4Rw","title":"index_title__VFy4x","content":"index_content__3PvaD","noData":"index_noData__oiuZ8"};